import { axios, BaseApiUrl,BaseUrl} from '../axios_config';

//装车单查询
export const getOutboundOrderAsync = params => {
    return axios.post(`${BaseApiUrl}/TFOutbound/GetOutboundList`, params);
};

//导出出库单
export const exportTFOutboundAsync = `${BaseApiUrl}/TFOutbound/TFOutboundAsyncOut`;

//导出出库单箱明细
export const exportTFOutboundBoxAsync = `${BaseApiUrl}/TFOutbound/TFOutboundAsyncBoxOut`;

//导出出库单拣货明细
export const exportTFOutboundPickAsync = `${BaseApiUrl}/TFOutbound/TFOutboundAsyncPick`;


//测量单查询
export const getMachineListAsync = params => {
    return axios.post(`${BaseApiUrl}/TFOutbound/GetMachineList`, params);
};
//到仓证明查询
export const getArriveWareListAsync = params => {
    return axios.post(`${BaseApiUrl}/TFOutbound/GetArriveWareList`, params);
};

//测量单导出
export function machineExportAsync(params) {
    return axios.post(`${BaseApiUrl}/TFOutbound/MachineExportAsync`, params);
}

//打印装车单查询
export const getOutboundOrderPrint = params => {
    return axios.get(`${BaseApiUrl}/TFOutbound/GetOutboundPickPrint`, { params: params });
};

//打印装车单
export const outboundOrderStatusPrint = params => {
    return axios.get(`${BaseApiUrl}/TFOutbound/OutboundStatusPrint`, { params: params });
};
//绑定出库单
export const outboundBind = params => {
    return axios.get(`${BaseApiUrl}/TFOutbound/OutboundBind`, { params: params });
};

//导出出库箱
export const exportTFOutboundBox = `${BaseApiUrl}/TFOutbound/ExportTFOutboundBox`;

//导入出库装箱数据
export const importTFOutboundBox = `${BaseApiUrl}/TFOutbound/ImportTFOutboundBox`;

//导出
export const exportTFOutOrder = `${BaseApiUrl}/TFOutbound/ExportTFOutOrder`;
//导入出库明细数据
export const importTFOutDeliveryOrder = `${BaseApiUrl}/TFOutbound/ImportTFOutDeliveryOrder`;

 //完成拣货
 export const outboundOverPicking = params =>{
    return axios.post(`${BaseApiUrl}/TFOutbound/OutboundOverPicking`, { ...params }).then(res => res.data);
};

//装车单发货详情
export const getOutboundSendDetail = params => {
    return axios.get(`${BaseApiUrl}/TFOutbound/GetOutboundSendDetail`, { params: params });
};

//装车单发货箱子详情
export const getOutboundSendBoxDetail = params => {
    return axios.get(`${BaseApiUrl}/TFOutbound/GetOutboundSendBoxList`, { params: params });
};

//确认出库
export const overSendSubmit = params => {
    return axios.post(`${BaseApiUrl}/TFOutbound/OutboundOverSend`, { ...params }).then(res => res.data);
};

//装车单详情
export const getOutboundDetail = params => {
    return axios.get(`${BaseApiUrl}/TFOutbound/GetOutboundDetail`, { params: params });
};


//预览装车图片
export const getOutboundReviewImages = params => {
    return axios.get(`${BaseApiUrl}/TFOutbound/GetOutboundInfoReviewImages`, { params: params });
};

//预览测量图片
export const getMachineReviewImages = params => {
    return axios.get(`${BaseApiUrl}/TFOutbound/GetMachineImages`, { params: params });
};

//下载装车图片
export const getOutboundReviewImagesFileOut = `${BaseApiUrl}/TFOutbound/GetOutboundReviewImagesFileOut`;
//下载设备图片
export const getActualDataImagesFileOut = `${BaseApiUrl}/TFOutbound/GetActualDataImagesFileOut`;

//仓库库区仓位列表
export const getAreaLocation = params => {
    return axios.get(`${BaseApiUrl}/WarehouseLocation/GetAreaLocation`, { params: params });
};
//按客户及仓库查询
export const getTFTemporaryStorage = params => {
    return axios.get(`${BaseApiUrl}/TFOutbound/GetTFTemporaryStorage`, { params: params });
};
//添加出库单
export const addTFOuntboundOrder = params => {
    return axios.post(`${BaseApiUrl}/TFOutbound/AddTFOuntboundOrder`, params);
};
//出库单修改判断是否异常
export const JudgeOutboundInfoIsAbnormal = params => {
    return axios.get(`${BaseApiUrl}/TFOutbound/JudgeOutboundInfoIsAbnormal`, { params: params });
};

//打印装车单查询
export const getLoadInfoPrint = params => {
    return axios.get(`${BaseApiUrl}/TFOutbound/GetLoadInfoPrint`, { params: params });
};

//查询出库单详情
export const getOutboundInfoByID = params => {
    return axios.get(`${BaseApiUrl}/TFOutbound/GetOutboundInfoByID`, { params: params });
};
//打托
export const addTFPallet = params => {
    return axios.post(`${BaseApiUrl}/TFOutbound/AddTFPallet`, params);
};

export const bingActualData = params => {
    return axios.post(`${BaseApiUrl}/TFOutbound/bingActualData`, params);
};

export const delActualData = params => {
    return axios.post(`${BaseApiUrl}/TFOutbound/delActualData`, params);
};

export const addAppointArrive = params => {
    return axios.post(`${BaseApiUrl}/TFOutbound/AddAppointArrive`, params);
};

//新增出库明细单
export const addTFOutDeliveryOrder = params => {
    return axios.get(`${BaseApiUrl}/TFOutbound/AddTFOutDeliveryOrder`, { params: params });
};

//新增在库箱明细
export const getInStockBoxInfo = params => {
    return axios.get(`${BaseApiUrl}/TFOutbound/GetInStockBoxInfo`, { params: params });
};
